module.exports = __webpack_public_path__ + "pc/img/img3.acb840b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onOne/cao/img3.png
// module id = sHfX
// module chunks = 3